import type { Utility } from '../../../types/utility';

const base: Utility.CSSProperties = {
  position: 'relative',
  alignItems: 'center',
  borderWidth: '0',
  borderStyle: 'solid',
  borderColor: 'coolGrey.40',
  display: 'flex',
  justifyContent: 'stretch',
  width: '100%',
  '&:hover': {
    cursor: 'pointer',
  },
  '&:focus-within': {
    outline: '2px solid',
    outlineColor: 'indigo.100',
  },
};

const chart = {
  default: {
    ...base,
    padding: 's8',
    paddingLeft: 's16',
    paddingRight: 's16',
    borderRadius: 'r2',
    borderWidth: '1px',
    minWidth: '215px',
    backgroundColor: 'white',
  },
  search: {
    ...base,
    padding: 's8',
    paddingLeft: 's16',
    paddingRight: 's16',
    borderRadius: 'r2',
    borderWidth: '1px',
    minWidth: '215px',
    backgroundColor: 'white',
    '&:focus-within': {
      outline: 'none',
    },
  },
  bottomLine: {
    ...base,
    borderBottomWidth: '1px',
    padding: 's8',
    paddingLeft: 's16',
    paddingRight: 's16',
  },
  thickBottomLine: {
    ...base,
    borderColor: 'coolGrey.100',
    borderBottomWidth: '4px',
    padding: 's8',
    paddingLeft: 's8',
    paddingRight: 's8',
  },
  paddedSquare: {
    ...base,
    borderRadius: 'r2',
    borderColor: 'coolGrey.100',
    borderWidth: '1px',
    padding: 's8',
    paddingLeft: 's16',
    paddingRight: 's16',
  },
  paddedRounded: {
    ...base,
    borderRadius: 'r4',
    borderColor: 'coolGrey.60',
    borderWidth: '1px',
    padding: '13px',
    paddingLeft: 's16',
    paddingRight: 's16',
  },
  form: {
    ...base,
    height: '50px',
    padding: 's8',
    paddingLeft: 's16',
    paddingRight: 's16',
    borderRadius: 'r2',
    borderColor: 'coolGrey.80',
    borderWidth: '1px',
  },
};

const box: Utility.VariantKeyModes<BoxVariantsType> = {
  ...chart,
  products: {
    chart,
    chartblog: chart,
    co: chart,
    edu: chart,
    scale: chart,
    spark: chart,
  },
};

export type BoxVariantsType =
  | 'default'
  | 'bottomLine'
  | 'thickBottomLine'
  | 'paddedSquare'
  | 'paddedRounded'
  | 'form'
  | 'search';
export const boxVariants = Object.keys(chart) as BoxVariantsType[];

export default box;
